/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./button.widget";
var styles_ButtonWidget = [];
var RenderType_ButtonWidget = i0.ɵcrt({ encapsulation: 2, styles: styles_ButtonWidget, data: {} });
export { RenderType_ButtonWidget as RenderType_ButtonWidget };
export function View_ButtonWidget_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { element: 0 }), (_l()(), i0.ɵeld(1, 0, [[1, 0], ["ref", 1]], null, 1, "button", [], [[8, "className", 0]], [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.button.action($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i0.ɵted(2, null, ["", ""])), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.classes; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.button.label; _ck(_v, 2, 0, currVal_1); }); }
export function View_ButtonWidget_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "sp-button-widget", [], null, null, null, View_ButtonWidget_0, RenderType_ButtonWidget)), i0.ɵdid(1, 4374528, null, 0, i1.ButtonWidget, [], null, null)], null, null); }
var ButtonWidgetNgFactory = i0.ɵccf("sp-button-widget", i1.ButtonWidget, View_ButtonWidget_Host_0, {}, {}, []);
export { ButtonWidgetNgFactory as ButtonWidgetNgFactory };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/button.widget.ngfactory.js.pre-build-optimizer.js